import { Dispatch } from "redux";

// types
import { IAuthActionTypes } from "models/IAuthState";
import { IHistory } from "models/ICommon";

// services
import authService from "services/authService";

import deleteAccountService from "services/deleteAccountService";

import { IDeleteAccountActionTypes } from "../reducers/deleteAccount.reducer";

// configs
import { PATH_NAME } from "configs";
import { IAppActionTypes } from "models/IAppState";

type otpResponse = {
  data?: {
    user_id: string;
    entity_id: string;
    auth_token: string;
    user_name: string;
  };
  error?: any;
};

export const deActivateUserAccount =
  (userID: string | undefined) =>
  async (dispatch: Dispatch<any>) => {
    dispatch({ type: IDeleteAccountActionTypes.USER_DELETE_REQUEST });

    const response: otpResponse =
      await deleteAccountService.deActiveUserAccount(userID);

    try {
      if (response.error) {
        dispatch({
          type: IDeleteAccountActionTypes.USER_DELETE_FAILURE,
          payload: {
            error: "Delete account failure",
          },
        });

        setTimeout(() => {
          dispatch({
            type: "HIDE_ALERT",
          });
        }, 2000);
        return;
      }

      dispatch({
        type: IDeleteAccountActionTypes.USER_DELETE_SUCCESS,
      });

      setTimeout(() => {
        dispatch({
          type: "HIDE_ALERT",
        });
      }, 2000);
    } catch (error) {
      dispatch({
        type: IDeleteAccountActionTypes.USER_DELETE_FAILURE,
        payload: {
          error: "Delete account failure",
        },
      });

      setTimeout(() => {
        dispatch({
          type: "HIDE_ALERT",
        });
      }, 2000);
    }
  };

export const deleteUserAccountPermanent =
  (userID: string | undefined) =>
  async (dispatch: Dispatch<any>) => {
    dispatch({ type: IDeleteAccountActionTypes.USER_DELETE_REQUEST });

    const response: otpResponse =
      await deleteAccountService.deleteUserAccountPermanent(
        userID
      );

    try {
      if (response.error) {
        dispatch({
          type: IDeleteAccountActionTypes.USER_DELETE_FAILURE,
          payload: {
            errror: "Delete user failure",
          },
        });

        setTimeout(() => {
          dispatch({
            type: "HIDE_ALERT",
          });
        }, 2000);
        return;
      }
      // dispatch({
      dispatch({
        type: IDeleteAccountActionTypes.USER_DELETE_SUCCESS,
      });

      setTimeout(() => {
        dispatch({
          type: "HIDE_ALERT",
        });
      }, 2000);
    } catch (error) {
      dispatch({
        type: IDeleteAccountActionTypes.USER_DELETE_FAILURE,
        payload: {
          errror: "Delete user failure",
        },
      });

      setTimeout(() => {
        dispatch({
          type: "HIDE_ALERT",
        });
      }, 2000);
    }
  };
